import { GraphQLClient } from 'graphql-request'
import { PriceQueryResult, TokenPrice } from '../api-types'
import { pricesQuery } from '../subgraph/queries/prices'

export async function callSubgraphPrices(
  client: GraphQLClient
): Promise<TokenPrice[]> {
  const result: PriceQueryResult[] = (await client.request(pricesQuery))
    .tokenPrices
  const prices = result.map((p: any) => ({
    symbol: p.symbol as string,
    price: Number(p.price),
  }))
  return prices
}
